export default {
  setStatus (state, status) {
    state.status = status
  },

  setSelected (state, event) {
    state.selected = event
  },

  setPlaying (state, event) {
    state.playing = event
  }
}
